import _ from "lodash";
import axios from "axios";
import axiosFileupload from "axios-fileupload";
import {
  BASE_IMAGES_URL,
  INSTANCE_URL,
  itemCount,
  BASE_IMAGES_LOCAL_URL,
} from "Constants";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import { getHeaders } from "CommonUtils";
import {
  getRequest,
  postRequest,
  deleteRequest,
  fileUploadRequest,
  patchRequest,
  uploadEncodedFile,
  deleteBulkRequest,
} from "NetworkCall";
import { randomstring } from "randomstring-js";

export var FETCH_ALL_EXHIBITORS = "fetch_all_exhibitors";
export var FETCH_EXHIBITORS = "fetch_exhibitors";
export var FETCH_ALL_PRODUCT_CATEGORY = "FETCH_ALL_PRODUCT_CATEGORY";
export var FETCH_ALL_PRODUCT_INDUSTRY = "FETCH_ALL_PRODUCT_INDUSTRY";
export var FETCH_ALL_PRODUCT_SUB_CATEGORY = "FETCH_ALL_PRODUCT_SUB_CATEGORY";
export var OPEN_EXHIBITOR_MODAL = "open_exhibitor_modal";
export var INSERT_EXHIBITORS = "insert_exhibitors";
export var DELETE_EXHIBITORS_SUCESS = "delete_exhibitors_success";
export var DELETE_EXHIBITORS_ERROR = "delete_exhibitors_error";
export var LOAD_EDIT_EXHIBITOR_DATA = "load_exhibitor_edit_data";
export var UPDATED_EXHIBITOR_IMAGE = "UPDATED_EXHIBITOR_IMAGE";
export var IMPORT_EXHIBITOR_MODAL = "IMPORT_EXHIBITOR_MODAL";
export var UPDATE_EXHIBITOR_FILES = "UPDATE_EXHIBITOR_FILES";
export var EXHIBITOR_FILES_CHANGED = "EXHIBITOR_FILES_CHANGED";
export var UPDATED_EXHIBITOR_BANNER = "UPDATED_EXHIBITOR_BANNER";
export var EXHIBITOR_WORKING_DYNAMIC_FORM = "EXHIBITOR_WORKING_DYNAMIC_FORM";
export var EXHIBITOR_COUNTING_NUMBERS = "EXHIBITOR_COUNTING_NUMBERS";

export function fetchAllExhibitors(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/exhibitors?related=appuser_by_exhibitoridfk&include_count=true&filter=eventid=${session.eventid}&order=createdon%20DESC`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: FETCH_ALL_EXHIBITORS,
          payload: { data: data.resource, count: data.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function fetchExhibitors(session, pageCount = 0, callback) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${perPage}&offset=${offset}`;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/exhibitors?related=appuser_by_exhibitoridfk&include_count=true&filter=eventid=${session.eventid}&order=createdon%20DESC${offSetQuery}`;

  var response = axios.get(url, getHeaders(session));

  return (dispatch) => {
    dispatch(showLoading());
    response
      .then(({ data }) => {
        dispatch({
          type: FETCH_EXHIBITORS,
          payload: { data: data.resource, count: data.meta.count },
        });
        dispatch(hideLoading());
        callback({ success: 1 });
      })
      .catch((error) => {
        callback({ success: 0 });
        dispatch(hideLoading());
      });
  };
}

export function searchExhibitors(session, search = "", pageCount = 0) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${perPage}&offset=${offset}`;
  var searchQuery = `(name like %25${search}%25)OR(booth like %25${search}%25)`;
  var filter = encodeURI(`(${searchQuery}) AND (eventid=${session.eventid})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/exhibitors?related=appuser_by_exhibitoridfk&include_count=true&filter=(${filter})&order=createdon%20DESC${offSetQuery}`;

  var response = axios.get(url, getHeaders(session));

  return (dispatch) => {
    dispatch(showLoading());
    response
      .then(({ data }) => {
        dispatch({
          type: FETCH_EXHIBITORS,
          payload: { data: data.resource, count: data.meta.count },
        });
        dispatch(hideLoading());
      })
      .catch((error) => {
        dispatch(hideLoading());
      });
  };
}

export function sortByName(session, sort = "az", pageCount = 0) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${perPage}&offset=${offset}`;
  var filter = encodeURI(`(eventid=${session.eventid})`);

  let orderBy = `&order=createdon%20DESC`;
  if (sort == "az") {
    orderBy = `&order=name%20ASC`;
  }
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/exhibitors?related=appuser_by_exhibitoridfk&include_count=true&filter=(${filter})${orderBy}${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: FETCH_EXHIBITORS,
          payload: { data: data.resource, count: data.meta.count },
        });
      },
      (error) => {}
    );
  };
}

export function fetchProductAllIndustry(session, callback) {
  var filter = encodeURI(`(isactive=1)`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/master_industry`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: FETCH_ALL_PRODUCT_INDUSTRY,
          payload: { data: data.resource, count: data.meta.count },
        });
        callback({ success: 1, data: data.resource, count: data.meta.count });
      },
      (error) => {}
    );
  };
}

export function fetchProductAllCategory(session, callback) {
  // Event wise data query
  var filter1 = encodeURI(`(eventid=${session.eventid})AND(isactive=1)`);
  var url1 = `${INSTANCE_URL}/api/v2/eventify/_table/master_category?fields=id,name&include_count=true&filter=(${filter1})&order=createdon%20DESC`;

  // Default data query
  var filter = encodeURI(`(eventid IS NULL)AND(isactive=1)`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/master_category?fields=id,name&include_count=true&filter=(${filter})&order=createdon%20DESC`;

  return (dispatch) => {
    getRequest(
      url1,
      session,
      dispatch,
      (data) => {
        if (data.resource.length > 0) {
          dispatch({
            type: FETCH_ALL_PRODUCT_CATEGORY,
            payload: { data: data.resource, count: data.meta.count },
          });
          callback({ success: 1, data: data.resource, count: data.meta.count });
        } else {
          getRequest(
            url,
            session,
            dispatch,
            (data) => {
              dispatch({
                type: FETCH_ALL_PRODUCT_CATEGORY,
                payload: { data: data.resource, count: data.meta.count },
              });
              callback({
                success: 1,
                data: data.resource,
                count: data.meta.count,
              });
            },
            (error) => {}
          );
        }
      },
      (error) => {}
    );
  };
}

export function fetchProductAllSubCategory(session, callback) {
  // Event wise data query
  var filter1 = encodeURI(`(eventid=${session.eventid})AND(isactive=1)`);
  var url1 = `${INSTANCE_URL}/api/v2/eventify/_table/master_subcategory?fields=id,categoryid,name&include_count=true&filter=(${filter1})&order=createdon%20DESC`;

  // Default data query
  var filter = encodeURI(`(eventid IS NULL)AND(isactive=1)`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/master_subcategory?fields=id,categoryid,name&include_count=true&filter=(${filter})&order=createdon%20DESC`;

  return (dispatch) => {
    getRequest(
      url1,
      session,
      dispatch,
      (data) => {
        if (data.resource.length > 0) {
          dispatch({
            type: FETCH_ALL_PRODUCT_SUB_CATEGORY,
            payload: { data: data.resource, count: data.meta.count },
          });
          callback({ success: 1, data: data.resource, count: data.meta.count });
        } else {
          getRequest(
            url,
            session,
            dispatch,
            (data) => {
              dispatch({
                type: FETCH_ALL_PRODUCT_SUB_CATEGORY,
                payload: { data: data.resource, count: data.meta.count },
              });
              callback({
                success: 1,
                data: data.resource,
                count: data.meta.count,
              });
            },
            (error) => {}
          );
        }
      },
      (error) => {}
    );
  };
}

export function openExhibitorModal(option) {
  return {
    type: OPEN_EXHIBITOR_MODAL,
    payload: option,
  };
}

export function updateExhibitorImage(image) {
  return {
    type: UPDATED_EXHIBITOR_IMAGE,
    payload: image,
  };
}

export function updateExhibitorBanner(image) {
  return {
    type: UPDATED_EXHIBITOR_BANNER,
    payload: image,
  };
}

export function workingDynamicForm(data) {
  return (dispatch) => {
    dispatch({ type: EXHIBITOR_WORKING_DYNAMIC_FORM, payload: data });
  };
}

export function deleteExhibitorAdv(session, exhibitorid, callback) {
  var filter = encodeURI(
    `(eventid=${session.eventid}) AND (relatedid=${exhibitorid})`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/advertisement/?filter=(${filter})`;

  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (data) => {
        callback({ error: 0, data: data });
      },
      (error) => {
        callback({ error: 1, error: error });
      }
    );
  };
}

// Below code is comented by Viany on 23-11-2020 as now we are not uploading the file separately and banner is added
// export function insertExhibitor(session,values,exhibitor,imagedata,filechanged,uploadFiles,callback){
//   //debugger;
//   var eventid = session.eventid;
//   values = {...values,eventid};

//   return (dispatch)=>{
//     if(imagedata && filechanged.ischanged) {

//       _uploadProfile(session, imagedata, dispatch, (profile) => {
//         if(profile.success) {
//           _uploadAttachedFiles(session, uploadFiles, dispatch, (attachments) => {
//             values = {
//               ...values,
//               profileimage: profile.data.path,
//               profilethumbimage: profile.data.path,
//               file1: attachments[0].file,
//               file2: attachments[1].file,
//               file3: attachments[2].file,
//               file4: attachments[3].file,
//               file5: attachments[4].file,
//             };
//             _createUpdateExhibitor(session,values,exhibitor,dispatch,(feedback)=>{
//               if(feedback.success) {
//                 dispatch(_updteAppuserExhibitors(session,values,exhibitor,feedback.exhibitorid,callback));
//               }
//               else {
//                 callback({error:0, data:feedback.data});
//               }
//             });
//             // dispatch(_createUpdateExhibitor(session,values,exhibitor,callback));
//           });
//         }
//         else {
//           callback({error:2, data:profile.data.message});
//         }
//       });
//     }
//     else if(imagedata && !filechanged.ischanged) {

//       _uploadProfile(session, imagedata, dispatch, (profile) => {
//         if(profile.success) {
//           values = {...values, profileimage: profile.data.path, profilethumbimage: profile.data.path};
//           _createUpdateExhibitor(session,values,exhibitor,dispatch,(feedback)=>{
//             if(feedback.success) {
//               dispatch(_updteAppuserExhibitors(session,values,exhibitor,feedback.exhibitorid,callback));
//             }
//             else {
//               callback({error:0, data:feedback.data});
//             }
//           });
//           // dispatch(_createUpdateExhibitor(session,values,exhibitor,callback));
//         }
//         else {
//           callback({error:2, data:profile.data.message});
//         }
//       });
//     }
//     else if(!imagedata && filechanged.ischanged) {

//       _uploadAttachedFiles(session, uploadFiles, dispatch, (attachments) => {
//         values = {
//           ...values,
//           file1: attachments[0].file,
//           file2: attachments[1].file,
//           file3: attachments[2].file,
//           file4: attachments[3].file,
//           file5: attachments[4].file,
//         };
//         _createUpdateExhibitor(session,values,exhibitor,dispatch,(feedback)=>{
//           if(feedback.success) {
//             dispatch(_updteAppuserExhibitors(session,values,exhibitor,feedback.exhibitorid,callback));
//           }
//           else {
//             callback({error:0, data:feedback.data});
//           }
//         });
//         // dispatch(_createUpdateExhibitor(session,values,exhibitor,callback));
//       });
//     }
//     else {

//       values = {...values};
//       _createUpdateExhibitor(session,values,exhibitor,dispatch,(feedback)=>{
//         if(feedback.success) {
//           dispatch(_updteAppuserExhibitors(session,values,exhibitor,feedback.exhibitorid,callback));
//         }
//         else {
//           callback({error:0, data:feedback.data});
//         }
//       });
//       // dispatch(_createUpdateExhibitor(session,values,exhibitor,callback));
//     }
//   }
// }

export function insertExhibitor(
  session,
  values,
  exhibitor,
  imagedata,
  bannerdata,
  filechanged,
  exhibitorWorkingDynamicForm,
  callback
) {
  //debugger;
  var eventid = session.eventid;
  values = { ...values, eventid };
  // debugger;

  // Remove blank values from all file fields fileArray
  if (
    exhibitorWorkingDynamicForm &&
    exhibitorWorkingDynamicForm.workingEventForm
  ) {
    _.map(exhibitorWorkingDynamicForm.workingEventForm, (obj) => {
      if (obj.key === "file" && obj.fileArray && obj.fileArray.length > 0) {
        var newFileArray = _.filter(obj.fileArray, (o) => {
          return o != "";
        });
        obj.fileArray = newFileArray;
      }
    });
  }

  // Fetch only files field
  var otherFilesData = _.filter(
    exhibitorWorkingDynamicForm.workingEventForm,
    (file) => {
      return file.key === "file";
    }
  );

  // Fetch dynamic field responses
  var responsesArray = JSON.parse(values.responses);

  // Remove blank group fields
  _.map(responsesArray, (obj) => {
    if (obj.key === "group" && obj.value && obj.value.length > 0) {
      if (obj.type === "products") {
        var newArray = _.filter(obj.value, (o) => {
          return (
            o.productimages != "" ||
            o.productcategory != "" ||
            o.productsubcategory != "" ||
            o.producttitle != "" ||
            o.productinfo != ""
          );
        });
        obj.value = newArray;
      } else if (obj.type === "coupons") {
        var newArray = _.filter(obj.value, (o) => {
          return (
            o.coupontitle != "" ||
            o.couponabout != "" ||
            o.couponecode != "" ||
            o.couponvalidtill != ""
          );
        });
        obj.value = newArray;
      } else if (obj.type === "deals") {
        var newArray = _.filter(obj.value, (o) => {
          return (
            o.dealtitle != "" || o.dealabout != "" || o.dealvalidtill != ""
          );
        });
        obj.value = newArray;
      }
    }
  });

  // Fetch only product group field data
  var groupProductData = _.filter(responsesArray, (data) => {
    return data.key === "group" && data.type === "products";
  });

  // debugger;
  return (dispatch) => {
    if (
      imagedata &&
      bannerdata &&
      filechanged.ischanged &&
      filechanged.productimagechanged
    ) {
      _uploadProfile(session, imagedata, dispatch, (profile) => {
        if (profile.success) {
          _uploadBanner(session, bannerdata, dispatch, (banner) => {
            if (banner.success) {
              _uploadDynamicFormsFiles(
                session,
                otherFilesData,
                dispatch,
                (filesArray) => {
                  _.map(filesArray, (obj) => {
                    var check = _.filter(responsesArray, function (file) {
                      return file.name === obj.name;
                    });
                    check[0].value = obj.fileArray;
                  });

                  _uploadGroupProductImage(
                    session,
                    groupProductData[0].value,
                    dispatch,
                    (product) => {
                      var check = _.filter(responsesArray, function (data) {
                        return data.key === "group" && data.type === "products";
                      });
                      check[0].value = product;

                      values = {
                        ...values,
                        profileimage: profile.data.path,
                        profilethumbimage: profile.data.path,
                        bannerimage: banner.data.path,
                        responses: JSON.stringify(responsesArray),
                      };

                      _createUpdateExhibitor(
                        session,
                        values,
                        exhibitor,
                        dispatch,
                        (feedback) => {
                          if (feedback.success) {
                            _createUpdateExhibitorProducts(
                              session,
                              values,
                              exhibitor,
                              feedback.exhibitorid,
                              dispatch,
                              (prores) => {
                                if (prores.success) {
                                  dispatch(
                                    _updteAppuserExhibitors(
                                      session,
                                      values,
                                      exhibitor,
                                      feedback.exhibitorid,
                                      callback
                                    )
                                  );
                                } else {
                                  callback({ error: 4 });
                                }
                              }
                            );
                          } else {
                            callback({ error: 1 });
                          }
                        }
                      );
                    }
                  );
                }
              );
            } else {
              callback({ error: 2, data: banner.data.message });
            }
          });
        } else {
          callback({ error: 2, data: profile.data.message });
        }
      });
    } else if (
      imagedata &&
      bannerdata &&
      filechanged.ischanged &&
      !filechanged.productimagechanged
    ) {
      _uploadProfile(session, imagedata, dispatch, (profile) => {
        if (profile.success) {
          _uploadBanner(session, bannerdata, dispatch, (banner) => {
            if (banner.success) {
              _uploadDynamicFormsFiles(
                session,
                otherFilesData,
                dispatch,
                (filesArray) => {
                  _.map(filesArray, (obj) => {
                    var check = _.filter(responsesArray, function (file) {
                      return file.name === obj.name;
                    });
                    check[0].value = obj.fileArray;
                  });

                  values = {
                    ...values,
                    profileimage: profile.data.path,
                    profilethumbimage: profile.data.path,
                    bannerimage: banner.data.path,
                    responses: JSON.stringify(responsesArray),
                  };

                  _createUpdateExhibitor(
                    session,
                    values,
                    exhibitor,
                    dispatch,
                    (feedback) => {
                      if (feedback.success) {
                        _createUpdateExhibitorProducts(
                          session,
                          values,
                          exhibitor,
                          feedback.exhibitorid,
                          dispatch,
                          (prores) => {
                            if (prores.success) {
                              dispatch(
                                _updteAppuserExhibitors(
                                  session,
                                  values,
                                  exhibitor,
                                  feedback.exhibitorid,
                                  callback
                                )
                              );
                            } else {
                              callback({ error: 4 });
                            }
                          }
                        );
                      } else {
                        callback({ error: 1 });
                      }
                    }
                  );
                }
              );
            } else {
              callback({ error: 2, data: banner.data.message });
            }
          });
        } else {
          callback({ error: 2, data: profile.data.message });
        }
      });
    } else if (
      imagedata &&
      bannerdata &&
      !filechanged.ischanged &&
      filechanged.productimagechanged
    ) {
      _uploadProfile(session, imagedata, dispatch, (profile) => {
        if (profile.success) {
          _uploadBanner(session, bannerdata, dispatch, (banner) => {
            if (banner.success) {
              _uploadGroupProductImage(
                session,
                groupProductData[0].value,
                dispatch,
                (product) => {
                  var check = _.filter(responsesArray, function (data) {
                    return data.key === "group" && data.type === "products";
                  });
                  check[0].value = product;

                  values = {
                    ...values,
                    profileimage: profile.data.path,
                    profilethumbimage: profile.data.path,
                    bannerimage: banner.data.path,
                    responses: JSON.stringify(responsesArray),
                  };

                  _createUpdateExhibitor(
                    session,
                    values,
                    exhibitor,
                    dispatch,
                    (feedback) => {
                      if (feedback.success) {
                        _createUpdateExhibitorProducts(
                          session,
                          values,
                          exhibitor,
                          feedback.exhibitorid,
                          dispatch,
                          (prores) => {
                            if (prores.success) {
                              dispatch(
                                _updteAppuserExhibitors(
                                  session,
                                  values,
                                  exhibitor,
                                  feedback.exhibitorid,
                                  callback
                                )
                              );
                            } else {
                              callback({ error: 4 });
                            }
                          }
                        );
                      } else {
                        callback({ error: 1 });
                      }
                    }
                  );
                }
              );
            } else {
              callback({ error: 2, data: banner.data.message });
            }
          });
        } else {
          callback({ error: 2, data: profile.data.message });
        }
      });
    } else if (
      imagedata &&
      !bannerdata &&
      filechanged.ischanged &&
      filechanged.productimagechanged
    ) {
      _uploadProfile(session, imagedata, dispatch, (profile) => {
        if (profile.success) {
          _uploadDynamicFormsFiles(
            session,
            otherFilesData,
            dispatch,
            (filesArray) => {
              _.map(filesArray, (obj) => {
                var check = _.filter(responsesArray, function (file) {
                  return file.name === obj.name;
                });
                check[0].value = obj.fileArray;
              });

              _uploadGroupProductImage(
                session,
                groupProductData[0].value,
                dispatch,
                (product) => {
                  var check = _.filter(responsesArray, function (data) {
                    return data.key === "group" && data.type === "products";
                  });
                  check[0].value = product;

                  values = {
                    ...values,
                    profileimage: profile.data.path,
                    profilethumbimage: profile.data.path,
                    responses: JSON.stringify(responsesArray),
                  };

                  _createUpdateExhibitor(
                    session,
                    values,
                    exhibitor,
                    dispatch,
                    (feedback) => {
                      if (feedback.success) {
                        _createUpdateExhibitorProducts(
                          session,
                          values,
                          exhibitor,
                          feedback.exhibitorid,
                          dispatch,
                          (prores) => {
                            if (prores.success) {
                              dispatch(
                                _updteAppuserExhibitors(
                                  session,
                                  values,
                                  exhibitor,
                                  feedback.exhibitorid,
                                  callback
                                )
                              );
                            } else {
                              callback({ error: 4 });
                            }
                          }
                        );
                      } else {
                        callback({ error: 1 });
                      }
                    }
                  );
                }
              );
            }
          );
        } else {
          callback({ error: 2, data: profile.data.message });
        }
      });
    } else if (
      !imagedata &&
      bannerdata &&
      filechanged.ischanged &&
      filechanged.productimagechanged
    ) {
      _uploadBanner(session, bannerdata, dispatch, (banner) => {
        if (banner.success) {
          _uploadDynamicFormsFiles(
            session,
            otherFilesData,
            dispatch,
            (filesArray) => {
              _.map(filesArray, (obj) => {
                var check = _.filter(responsesArray, function (file) {
                  return file.name === obj.name;
                });
                check[0].value = obj.fileArray;
              });

              _uploadGroupProductImage(
                session,
                groupProductData[0].value,
                dispatch,
                (product) => {
                  var check = _.filter(responsesArray, function (data) {
                    return data.key === "group" && data.type === "products";
                  });
                  check[0].value = product;

                  values = {
                    ...values,
                    bannerimage: banner.data.path,
                    responses: JSON.stringify(responsesArray),
                  };

                  _createUpdateExhibitor(
                    session,
                    values,
                    exhibitor,
                    dispatch,
                    (feedback) => {
                      if (feedback.success) {
                        _createUpdateExhibitorProducts(
                          session,
                          values,
                          exhibitor,
                          feedback.exhibitorid,
                          dispatch,
                          (prores) => {
                            if (prores.success) {
                              dispatch(
                                _updteAppuserExhibitors(
                                  session,
                                  values,
                                  exhibitor,
                                  feedback.exhibitorid,
                                  callback
                                )
                              );
                            } else {
                              callback({ error: 4 });
                            }
                          }
                        );
                      } else {
                        callback({ error: 1 });
                      }
                    }
                  );
                }
              );
            }
          );
        } else {
          callback({ error: 2, data: banner.data.message });
        }
      });
    } else if (
      imagedata &&
      bannerdata &&
      !filechanged.ischanged &&
      !filechanged.productimagechanged
    ) {
      _uploadProfile(session, imagedata, dispatch, (profile) => {
        if (profile.success) {
          _uploadBanner(session, bannerdata, dispatch, (banner) => {
            if (banner.success) {
              values = {
                ...values,
                profileimage: profile.data.path,
                profilethumbimage: profile.data.path,
                bannerimage: banner.data.path,
              };
              _createUpdateExhibitor(
                session,
                values,
                exhibitor,
                dispatch,
                (feedback) => {
                  if (feedback.success) {
                    _createUpdateExhibitorProducts(
                      session,
                      values,
                      exhibitor,
                      feedback.exhibitorid,
                      dispatch,
                      (prores) => {
                        if (prores.success) {
                          dispatch(
                            _updteAppuserExhibitors(
                              session,
                              values,
                              exhibitor,
                              feedback.exhibitorid,
                              callback
                            )
                          );
                        } else {
                          callback({ error: 4 });
                        }
                      }
                    );
                  } else {
                    callback({ error: 1 });
                  }
                }
              );
            } else {
              callback({ error: 2, data: banner.data.message });
            }
          });
        } else {
          callback({ error: 2, data: profile.data.message });
        }
      });
    } else if (
      imagedata &&
      !bannerdata &&
      filechanged.ischanged &&
      !filechanged.productimagechanged
    ) {
      _uploadProfile(session, imagedata, dispatch, (profile) => {
        if (profile.success) {
          _uploadDynamicFormsFiles(
            session,
            otherFilesData,
            dispatch,
            (filesArray) => {
              _.map(filesArray, (obj) => {
                var check = _.filter(responsesArray, function (file) {
                  return file.name === obj.name;
                });
                check[0].value = obj.fileArray;
              });

              values = {
                ...values,
                profileimage: profile.data.path,
                profilethumbimage: profile.data.path,
                responses: JSON.stringify(responsesArray),
              };

              _createUpdateExhibitor(
                session,
                values,
                exhibitor,
                dispatch,
                (feedback) => {
                  if (feedback.success) {
                    _createUpdateExhibitorProducts(
                      session,
                      values,
                      exhibitor,
                      feedback.exhibitorid,
                      dispatch,
                      (prores) => {
                        if (prores.success) {
                          dispatch(
                            _updteAppuserExhibitors(
                              session,
                              values,
                              exhibitor,
                              feedback.exhibitorid,
                              callback
                            )
                          );
                        } else {
                          callback({ error: 4 });
                        }
                      }
                    );
                  } else {
                    callback({ error: 1 });
                  }
                }
              );
            }
          );
        } else {
          callback({ error: 2, data: profile.data.message });
        }
      });
    } else if (
      imagedata &&
      !bannerdata &&
      !filechanged.ischanged &&
      filechanged.productimagechanged
    ) {
      _uploadProfile(session, imagedata, dispatch, (profile) => {
        if (profile.success) {
          _uploadGroupProductImage(
            session,
            groupProductData[0].value,
            dispatch,
            (product) => {
              var check = _.filter(responsesArray, function (data) {
                return data.key === "group" && data.type === "products";
              });
              check[0].value = product;

              values = {
                ...values,
                profileimage: profile.data.path,
                profilethumbimage: profile.data.path,
                responses: JSON.stringify(responsesArray),
              };

              _createUpdateExhibitor(
                session,
                values,
                exhibitor,
                dispatch,
                (feedback) => {
                  if (feedback.success) {
                    _createUpdateExhibitorProducts(
                      session,
                      values,
                      exhibitor,
                      feedback.exhibitorid,
                      dispatch,
                      (prores) => {
                        if (prores.success) {
                          dispatch(
                            _updteAppuserExhibitors(
                              session,
                              values,
                              exhibitor,
                              feedback.exhibitorid,
                              callback
                            )
                          );
                        } else {
                          callback({ error: 4 });
                        }
                      }
                    );
                  } else {
                    callback({ error: 1 });
                  }
                }
              );
            }
          );
        } else {
          callback({ error: 2, data: profile.data.message });
        }
      });
    } else if (
      !imagedata &&
      bannerdata &&
      filechanged.ischanged &&
      !filechanged.productimagechanged
    ) {
      _uploadBanner(session, bannerdata, dispatch, (banner) => {
        if (banner.success) {
          _uploadDynamicFormsFiles(
            session,
            otherFilesData,
            dispatch,
            (filesArray) => {
              _.map(filesArray, (obj) => {
                var check = _.filter(responsesArray, function (file) {
                  return file.name === obj.name;
                });
                check[0].value = obj.fileArray;
              });

              values = {
                ...values,
                bannerimage: banner.data.path,
                responses: JSON.stringify(responsesArray),
              };

              _createUpdateExhibitor(
                session,
                values,
                exhibitor,
                dispatch,
                (feedback) => {
                  if (feedback.success) {
                    _createUpdateExhibitorProducts(
                      session,
                      values,
                      exhibitor,
                      feedback.exhibitorid,
                      dispatch,
                      (prores) => {
                        if (prores.success) {
                          dispatch(
                            _updteAppuserExhibitors(
                              session,
                              values,
                              exhibitor,
                              feedback.exhibitorid,
                              callback
                            )
                          );
                        } else {
                          callback({ error: 4 });
                        }
                      }
                    );
                  } else {
                    callback({ error: 1 });
                  }
                }
              );
            }
          );
        } else {
          callback({ error: 2, data: banner.data.message });
        }
      });
    } else if (
      !imagedata &&
      bannerdata &&
      !filechanged.ischanged &&
      filechanged.productimagechanged
    ) {
      _uploadBanner(session, bannerdata, dispatch, (banner) => {
        if (banner.success) {
          _uploadGroupProductImage(
            session,
            groupProductData[0].value,
            dispatch,
            (product) => {
              var check = _.filter(responsesArray, function (data) {
                return data.key === "group" && data.type === "products";
              });
              check[0].value = product;

              values = {
                ...values,
                bannerimage: banner.data.path,
                responses: JSON.stringify(responsesArray),
              };

              _createUpdateExhibitor(
                session,
                values,
                exhibitor,
                dispatch,
                (feedback) => {
                  if (feedback.success) {
                    _createUpdateExhibitorProducts(
                      session,
                      values,
                      exhibitor,
                      feedback.exhibitorid,
                      dispatch,
                      (prores) => {
                        if (prores.success) {
                          dispatch(
                            _updteAppuserExhibitors(
                              session,
                              values,
                              exhibitor,
                              feedback.exhibitorid,
                              callback
                            )
                          );
                        } else {
                          callback({ error: 4 });
                        }
                      }
                    );
                  } else {
                    callback({ error: 1 });
                  }
                }
              );
            }
          );
        } else {
          callback({ error: 2, data: banner.data.message });
        }
      });
    } else if (
      !imagedata &&
      !bannerdata &&
      filechanged.ischanged &&
      filechanged.productimagechanged
    ) {
      _uploadDynamicFormsFiles(
        session,
        otherFilesData,
        dispatch,
        (filesArray) => {
          _.map(filesArray, (obj) => {
            var check = _.filter(responsesArray, function (file) {
              return file.name === obj.name;
            });
            check[0].value = obj.fileArray;
          });

          _uploadGroupProductImage(
            session,
            groupProductData[0].value,
            dispatch,
            (product) => {
              var check = _.filter(responsesArray, function (data) {
                return data.key === "group" && data.type === "products";
              });
              check[0].value = product;

              values = {
                ...values,
                responses: JSON.stringify(responsesArray),
              };

              _createUpdateExhibitor(
                session,
                values,
                exhibitor,
                dispatch,
                (feedback) => {
                  if (feedback.success) {
                    _createUpdateExhibitorProducts(
                      session,
                      values,
                      exhibitor,
                      feedback.exhibitorid,
                      dispatch,
                      (prores) => {
                        if (prores.success) {
                          dispatch(
                            _updteAppuserExhibitors(
                              session,
                              values,
                              exhibitor,
                              feedback.exhibitorid,
                              callback
                            )
                          );
                        } else {
                          callback({ error: 4 });
                        }
                      }
                    );
                  } else {
                    callback({ error: 1 });
                  }
                }
              );
            }
          );
        }
      );
    } else if (
      imagedata &&
      !bannerdata &&
      !filechanged.ischanged &&
      !filechanged.productimagechanged
    ) {
      _uploadProfile(session, imagedata, dispatch, (profile) => {
        if (profile.success) {
          values = {
            ...values,
            profileimage: profile.data.path,
            profilethumbimage: profile.data.path,
          };
          _createUpdateExhibitor(
            session,
            values,
            exhibitor,
            dispatch,
            (feedback) => {
              if (feedback.success) {
                _createUpdateExhibitorProducts(
                  session,
                  values,
                  exhibitor,
                  feedback.exhibitorid,
                  dispatch,
                  (prores) => {
                    if (prores.success) {
                      dispatch(
                        _updteAppuserExhibitors(
                          session,
                          values,
                          exhibitor,
                          feedback.exhibitorid,
                          callback
                        )
                      );
                    } else {
                      callback({ error: 4 });
                    }
                  }
                );
              } else {
                callback({ error: 1 });
              }
            }
          );
        } else {
          callback({ error: 2, data: profile.data.message });
        }
      });
    } else if (
      !imagedata &&
      bannerdata &&
      !filechanged.ischanged &&
      !filechanged.productimagechanged
    ) {
      _uploadBanner(session, bannerdata, dispatch, (banner) => {
        if (banner.success) {
          values = {
            ...values,
            bannerimage: banner.data.path,
          };
          _createUpdateExhibitor(
            session,
            values,
            exhibitor,
            dispatch,
            (feedback) => {
              if (feedback.success) {
                _createUpdateExhibitorProducts(
                  session,
                  values,
                  exhibitor,
                  feedback.exhibitorid,
                  dispatch,
                  (prores) => {
                    if (prores.success) {
                      dispatch(
                        _updteAppuserExhibitors(
                          session,
                          values,
                          exhibitor,
                          feedback.exhibitorid,
                          callback
                        )
                      );
                    } else {
                      callback({ error: 4 });
                    }
                  }
                );
              } else {
                callback({ error: 1 });
              }
            }
          );
        } else {
          callback({ error: 2, data: banner.data.message });
        }
      });
    } else if (
      !imagedata &&
      !bannerdata &&
      filechanged.ischanged &&
      !filechanged.productimagechanged
    ) {
      _uploadDynamicFormsFiles(
        session,
        otherFilesData,
        dispatch,
        (filesArray) => {
          _.map(filesArray, (obj) => {
            var check = _.filter(responsesArray, function (file) {
              return file.name === obj.name;
            });
            check[0].value = obj.fileArray;
          });

          values = {
            ...values,
            responses: JSON.stringify(responsesArray),
          };

          _createUpdateExhibitor(
            session,
            values,
            exhibitor,
            dispatch,
            (feedback) => {
              if (feedback.success) {
                _createUpdateExhibitorProducts(
                  session,
                  values,
                  exhibitor,
                  feedback.exhibitorid,
                  dispatch,
                  (prores) => {
                    if (prores.success) {
                      dispatch(
                        _updteAppuserExhibitors(
                          session,
                          values,
                          exhibitor,
                          feedback.exhibitorid,
                          callback
                        )
                      );
                    } else {
                      callback({ error: 4 });
                    }
                  }
                );
              } else {
                callback({ error: 1 });
              }
            }
          );
        }
      );
    } else if (
      !imagedata &&
      !bannerdata &&
      !filechanged.ischanged &&
      filechanged.productimagechanged
    ) {
      _uploadGroupProductImage(
        session,
        groupProductData[0].value,
        dispatch,
        (product) => {
          var check = _.filter(responsesArray, function (data) {
            return data.key === "group" && data.type === "products";
          });
          check[0].value = product;

          // debugger;

          values = {
            ...values,
            responses: JSON.stringify(responsesArray),
          };

          _createUpdateExhibitor(
            session,
            values,
            exhibitor,
            dispatch,
            (feedback) => {
              if (feedback.success) {
                _createUpdateExhibitorProducts(
                  session,
                  values,
                  exhibitor,
                  feedback.exhibitorid,
                  dispatch,
                  (prores) => {
                    if (prores.success) {
                      dispatch(
                        _updteAppuserExhibitors(
                          session,
                          values,
                          exhibitor,
                          feedback.exhibitorid,
                          callback
                        )
                      );
                    } else {
                      callback({ error: 4 });
                    }
                  }
                );
              } else {
                callback({ error: 1 });
              }
            }
          );
        }
      );
    } else {
      values = { ...values };
      _createUpdateExhibitor(
        session,
        values,
        exhibitor,
        dispatch,
        (feedback) => {
          if (feedback.success) {
            _createUpdateExhibitorProducts(
              session,
              values,
              exhibitor,
              feedback.exhibitorid,
              dispatch,
              (prores) => {
                if (prores.success) {
                  dispatch(
                    _updteAppuserExhibitors(
                      session,
                      values,
                      exhibitor,
                      feedback.exhibitorid,
                      callback
                    )
                  );
                } else {
                  callback({ error: 4 });
                }
              }
            );
          } else {
            callback({ error: 1 });
          }
        }
      );
    }
  };
}

export function _uploadProfile(session, imagedata, dispatch, callback) {
  var eventid = session.eventid;
  imagedata = imagedata.replace(/^data:image\/[a-z]+;base64,/, "");
  var filename = `eventify/${eventid}/images/exhibitors/${randomstring(
    32
  )}.png`;
  var imageJson = {
    resource: [
      {
        name: filename,
        type: "file",
        is_base64: true,
        content: imagedata,
      },
    ],
  };

  uploadEncodedFile(
    `${BASE_IMAGES_URL}?check_exist=false`,
    session,
    imageJson,
    dispatch,
    (data) => {
      callback({ success: 1, data: data });
    },
    (error) => {
      callback({ success: 0, message: error });
    }
  );
}

export function _uploadBanner(session, imagedata, dispatch, callback) {
  var eventid = session.eventid;
  imagedata = imagedata.replace(/^data:image\/[a-z]+;base64,/, "");
  var filename = `eventify/${eventid}/images/exhibitors/banner/${randomstring(
    32
  )}.png`;
  var imageJson = {
    resource: [
      {
        name: filename,
        type: "file",
        is_base64: true,
        content: imagedata,
      },
    ],
  };

  uploadEncodedFile(
    `${BASE_IMAGES_URL}?check_exist=false`,
    session,
    imageJson,
    dispatch,
    (data) => {
      callback({ success: 1, data: data });
    },
    (error) => {
      callback({ success: 0, message: error });
    }
  );
}

export function _uploadAttachedFiles(session, uploadFiles, dispatch, callback) {
  var promiseArray = [];
  var eventid = session.eventid;
  _.map(uploadFiles, (item, index) => {
    promiseArray.push(
      new Promise((resolve, reject) => {
        var file = item.file;
        var name = item.filename;
        var n = file.search(";base64,");
        if (n > 0) {
          var content = file.split(";base64,")[1];
          var fileCustomName = name.substr(0, name.lastIndexOf("."));
          var fileType = name.split(".").pop();

          var filename = `eventify/${eventid}/files/exhibitors/${fileCustomName}_${randomstring(
            32
          )}.${fileType}`;
          var imageJson = {
            resource: [
              {
                name: filename,
                type: "file",
                is_base64: true,
                content: content,
              },
            ],
          };
          uploadEncodedFile(
            `${BASE_IMAGES_URL}?check_exist=false`,
            session,
            imageJson,
            dispatch,
            (data) => {
              uploadFiles[index].file = data.name;
              resolve();
            },
            (error) => {
              // callback({success:2, message:error});
            }
          );
        } else if (file == "") {
          uploadFiles[index].file = null;
          resolve();
        } else {
          uploadFiles[index].file = file;
          resolve();
        }
      })
    );
  });

  Promise.all(promiseArray).then(() => {
    callback({ ...uploadFiles });
  });
}

export function _uploadGroupProductImage(
  session,
  uploadFiles,
  dispatch,
  callback
) {
  var promiseArray = [];
  var eventid = session.eventid;
  _.map(uploadFiles, (item, index) => {
    promiseArray.push(
      new Promise((resolve, reject) => {
        var file = item.productimages;
        var n = file.search(";base64,");
        if (n > 0) {
          var content = file.split(";base64,")[1];
          var filename = `eventify/${eventid}/files/exhibitors/productimages/${randomstring(
            32
          )}.png`;
          var imageJson = {
            resource: [
              {
                name: filename,
                type: "file",
                is_base64: true,
                content: content,
              },
            ],
          };
          uploadEncodedFile(
            `${BASE_IMAGES_URL}?check_exist=false`,
            session,
            imageJson,
            dispatch,
            (data) => {
              uploadFiles[index].productimages = data.name;
              resolve();
            },
            (error) => {
              // callback({success:2, message:error});
            }
          );
        } else if (file == "") {
          uploadFiles[index].productimages = "";
          resolve();
        } else {
          uploadFiles[index].productimages = file;
          resolve();
        }
      })
    );
  });

  Promise.all(promiseArray).then(() => {
    callback(uploadFiles);
  });
}

export function _uploadDynamicFormsFiles(
  session,
  otherFilesData,
  dispatch,
  callback
) {
  // uploadFiles
  var promiseArray = [];
  var eventid = session.eventid;
  _.map(otherFilesData, (field, key) => {
    // Files field array
    var uploadFiles = field.fileArray;
    var fileCategory =
      field.name === "galleryimages"
        ? "galleryimages"
        : field.name === "galleryvideos"
        ? "galleryvideos"
        : field.name === "documents"
        ? "documents"
        : "otherfiles";
    _.map(uploadFiles, (item, index) => {
      if (item) {
        promiseArray.push(
          new Promise((resolve, reject) => {
            var file = item.file;
            var name = item.filename;
            var n = file.search(";base64,");
            if (n > 0) {
              var content = file.split(";base64,")[1];
              var fileCustomName = name.substr(0, name.lastIndexOf("."));
              var fileType = name.split(".").pop();
              var rand_num = randomstring(32);
              if (fileCategory == "galleryvideos") {
                /* 
                For videos we replacing all special characters and spaces with "_" as generating thumbnail do not support special char and spaces in file name
                */
                fileCustomName = fileCustomName.replace(
                  /[&\/\\#,+()$~%.'":*?<>{}\s]/g,
                  "_"
                );
              }
              // var filename = `eventify/${eventid}/files/exhibitors/${fileCategory}/${fileCustomName}_${randomstring.generate()}.${fileType}`;
              var filename = `eventify/${eventid}/files/exhibitors/${fileCategory}/${fileCustomName}_${rand_num}.${fileType}`;

              var imageJson = {
                resource: [
                  {
                    name: filename,
                    type: "file",
                    is_base64: true,
                    content: content,
                  },
                ],
              };
              /* 
               This Section will uplaod files in aws server but ->
               if "galleryvideos" then it will uplaod to local [file3]
               Vinay changed this to upload video in s3 on - 09-03-2023 
              */
              uploadEncodedFile(
                `${
                  fileCategory === "galleryvideos"
                    ? BASE_IMAGES_URL
                    : BASE_IMAGES_URL
                }?check_exist=false`,
                session,
                imageJson,
                dispatch,
                (data) => {
                  /* 
                  This Section will create thubmnail for a video file from local [file3] if "galleryvideos" 
                  session,filename,foldername,thumbnail name, for {exhibitors/sponsors etc}
                  */

                  // Below code is commented by Vinay on 11-04-2023, as this is not required, we are creating video thumb at time of video upload.
                  // if (fileCategory == "galleryvideos") {
                  //   _callVideoThumbanilReatorFc(
                  //     session,
                  //     `${fileCustomName}_${rand_num}.${fileType}`,
                  //     `eventify/${eventid}/files/exhibitors/${fileCategory}`,
                  //     `${fileCustomName}_${rand_num}.${fileType}.jpg`,
                  //     "exhibitors/galleryvideos/",
                  //     dispatch,
                  //     (res) => {
                  //       if (res.success) {
                  //       } else {
                  //         callback({ error: 1 });
                  //       }
                  //     }
                  //   );
                  // }

                  uploadFiles[index] = data.name;
                  resolve();
                },
                (error) => {
                  // callback({success:2, message:error});
                }
              );
            } else {
              uploadFiles[index] = file;
              resolve();
            }
          })
        );
      }
    });

    field.fileArray = uploadFiles;
  });

  Promise.all(promiseArray).then(() => {
    callback(otherFilesData);
  });
}

export function _createUpdateExhibitor(
  session,
  values,
  exhibitor,
  dispatch,
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/exhibitors/`;

  if (exhibitor.exhibitorid) {
    delete values["appuser_by_exhibitoridfk"];
    values = { resource: { ...values, exhibitorid: exhibitor.exhibitorid } };
  } else {
    values = { resource: values };
  }

  if (exhibitor.exhibitorid) {
    patchRequest(
      url,
      values,
      session,
      dispatch,
      (data) => {
        var exhibitorid = data.resource[0].exhibitorid;
        callback({ success: 1, exhibitorid: exhibitorid });
      },
      (error) => {
        callback({ success: 0, data: error });
      }
    );
  } else {
    postRequest(
      url,
      values,
      session,
      dispatch,
      (data) => {
        var exhibitorid = data.resource[0].exhibitorid;
        callback({ success: 1, exhibitorid: exhibitorid });
      },
      (error) => {
        callback({ success: 0, data: error });
      }
    );
  }
}

export function _createUpdateExhibitorProducts(
  session,
  values,
  exhibitor,
  exhibitorid,
  dispatch,
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/exhibitor_products/`;
  var responsesArray = JSON.parse(values.responses);
  var groupProductData = _.filter(responsesArray, (data) => {
    return data.key === "group" && data.type === "products";
  });

  var data = [];
  if (groupProductData.length > 0) {
    _.map(groupProductData[0].value, (item, index) => {
      let obj = {
        exhibitorid: exhibitorid,
        eventid: session.eventid,
        title: item.producttitle,
        description: item.productinfo,
        category: item.productcategory,
        subcategory: item.productsubcategory,
        image: item.productimages,
      };
      data.push(obj);
    });
  }
  var body = { resource: data };

  if (exhibitor.exhibitorid) {
    var filter = encodeURI(`(exhibitorid=${exhibitor.exhibitorid})`);
    var deleteUrl = `${INSTANCE_URL}/api/v2/eventify/_table/exhibitor_products?filter=${filter}`;
    deleteRequest(
      deleteUrl,
      session,
      dispatch,
      (delres) => {
        if (body.resource.length > 0) {
          postRequest(
            url,
            body,
            session,
            dispatch,
            (data) => {
              callback({ success: 1 });
            },
            (error) => {
              callback({ success: 0, data: error });
            }
          );
        } else {
          callback({ success: 1 });
        }
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  } else {
    if (body.resource.length > 0) {
      postRequest(
        url,
        body,
        session,
        dispatch,
        (data) => {
          callback({ success: 1 });
        },
        (error) => {
          callback({ success: 0, data: error });
        }
      );
    } else {
      callback({ success: 1 });
    }
  }
}

function _updteAppuserExhibitors(
  session,
  values,
  exhibitor,
  exhibitorid,
  callback
) {
  var selectedUsersStr = values.permittedusers;

  // Update with null of the exhibitorid, and then update with new exhibitorid to the selected appusers
  var filter = `((eventid=${session.eventid}) AND (exhibitoridfk=${exhibitorid}))`;
  var urlClear = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?filter=${filter}`;
  var bodyNull = { resource: [{ exhibitoridfk: null }] };

  return (dispatch) => {
    if (selectedUsersStr != "") {
      var selectedUsers = JSON.parse(selectedUsersStr);
      //Update with exhibitorid to all the selected appuser
      var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser`;
      var update = [];
      _.map(selectedUsers, (item) => {
        update.push({
          appuserid: item.appuserid,
          eventid: session.eventid,
          exhibitoridfk: exhibitorid,
        });
      });
      var body = { resource: update };

      var successCallback = (data) => {
        // dispatch(fetchExhibitors(session));
        var returnData = { error: 0, data: data };
        callback(returnData);
      };

      var errorCallback = (error) => {
        var returnData = { error: 1, data: error };
        callback(returnData);
      };

      if (exhibitor.exhibitorid) {
        patchRequest(
          urlClear,
          bodyNull,
          session,
          dispatch,
          (data) => {
            patchRequest(
              url,
              body,
              session,
              dispatch,
              successCallback,
              errorCallback
            );
          },
          (error) => {
            callback({ error: 1, data: error });
          }
        );
      } else {
        patchRequest(
          url,
          body,
          session,
          dispatch,
          successCallback,
          errorCallback
        );
      }
    } else {
      if (exhibitor.exhibitorid) {
        patchRequest(
          urlClear,
          bodyNull,
          session,
          dispatch,
          (data) => {
            // dispatch(fetchExhibitors(session));
            var returnData = { error: 0 };
            callback(returnData);
          },
          (error) => {
            callback({ error: 1, data: error });
          }
        );
      } else {
        // dispatch(fetchExhibitors(session));
        var returnData = { error: 0 };
        callback(returnData);
      }
    }
  };
}

export function updateExhibitorFiles(file) {
  return (dispatch) => {
    dispatch({ type: UPDATE_EXHIBITOR_FILES, payload: file });
  };
}

export function filesChanged(obj) {
  return (dispatch) => {
    dispatch({ type: EXHIBITOR_FILES_CHANGED, payload: obj });
  };
}

export function loadExhibitorData(exhibitor) {
  return {
    type: LOAD_EDIT_EXHIBITOR_DATA,
    payload: exhibitor,
  };
}

export function deleteExhibitor(session, exhibitorid, callback) {
  return (dispatch) => {
    var deleteUrl = `${INSTANCE_URL}/api/v2/eventify/_table/exhibitors/${exhibitorid}`;
    deleteRequest(
      deleteUrl,
      session,
      dispatch,
      (data) => {
        callback({ success: 1 });
        // dispatch(fetchExhibitors(session));
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };

  // var response = axios.delete(url,getHeaders(session));
  // return (dispatch)=>{
  //   response.then(({data}) => {
  //     var deleteUrl = `${INSTANCE_URL}/api/v2/eventify/_table/exhibitors/${exhibitorid}`;
  //     deleteUrl.then(({data}) => {
  //       callback({error:0,data:data});
  //       dispatch(fetchExhibitors(session, ''));
  //     }).catch((error) => {
  //       callback({error:1,data:error});
  //     });
  //   }).catch((error) => {
  //     callback({error:1,data:error});
  //    });
  // };
}

export function deleteAssociatedAppuser(session, id, callback) {
  var deleteUrl = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?filter=(exhibitoridfk=${id})`;

  return (dispatch) => {
    deleteRequest(
      deleteUrl,
      session,
      dispatch,
      (data) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function isimportant(session, exhibitor, value, callback) {
  let body = { featured: value };
  let data = { resource: body };
  var filter = encodeURI(
    `(exhibitorid=${exhibitor.exhibitorid})AND(eventid=${exhibitor.eventid})`
  );
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/exhibitors?filter=(${filter})`;
  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (data) => {
        callback({ success: 1 });
        // dispatch(fetchExhibitors(session));
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

function isEmpty(obj) {
  // null and undefined are "empty"
  if (obj == null) return true;
  // Assume if it has a length property with a non-zero value
  // that that property is correct.
  if (obj.length > 0) return false;
  if (obj.length === 0) return true;
  // If it isn't an object at this point
  // it is empty, but it can't be anything *but* empty
  // Is it empty?  Depends on your application.
  if (typeof obj !== "object") return true;
  // Otherwise, does it have any properties of its own?
  // Note that this doesn't handle
  // toString and valueOf enumeration bugs in IE < 9
  for (var key in obj) {
    if (hasOwnProperty.call(obj, key)) return false;
  }
  return true;
}

export function openImportExhibitorModal(showModal) {
  return { type: IMPORT_EXHIBITOR_MODAL, payload: showModal };
}

export function importExhibitor(session, values, duplicateData, callback) {
  let eventid = session.eventid;
  var url = `${INSTANCE_URL}/api/v2/bulkuploadData`;
  var body = {
    exhibitorlist: values,
    eventid: eventid,
    duplicateData: duplicateData,
    source: "exhibitor",
  };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        // dispatch(fetchExhibitors(session));
        if (response.count > 0) {
          callback({ success: 1, count: response.count });
        } else {
          callback({ success: 2 });
        }
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

/* This function created for  */
export function _callVideoThumbanilReatorFc(
  session,
  file_name,
  folder_name,
  thumb_name,
  subfolder_name,
  dispatch,
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
  var postData = {
    filename: file_name,
    foldername: folder_name,
    thumbname: thumb_name,
    subfoldername: subfolder_name,
    eventid: session.eventid,
    type: "createThumbFromVideo",
  };
  postRequest(
    url,
    postData,
    session,
    dispatch,
    (response) => {
      callback({ success: 1, data: response });
    },
    (error) => {
      callback({ success: 0, data: error });
    }
  );
}

export function fetchDownloadExhibitorInfo(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript/downloadexhibitorinfo`;
  var body = { eventid: session.eventid };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (data) => {
        callback({ success: 1, data: data.result, count: data.count });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function getExhibitorCounts(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
  var postData = {
    eventid: session.eventid,
    type: "exhibitorscount",
  };

  return (dispatch) => {
    postRequest(
      url,
      postData,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: EXHIBITOR_COUNTING_NUMBERS,
          payload: data,
        });
        callback({ success: 1, result: data });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function deleteAllExhibitors(session, callback) {
  var filter = encodeURI(`filter=(eventid=${session.eventid})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/exhibitors?${filter}`;

  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (data) => {
        callback({ error: 0, data: data });
      },
      (error) => {
        callback({ error: 1, data: error });
      }
    );
  };
}

export function deleteBulkExhibitors(session, appUser, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/exhibitors`;
  var body = {
    resource: appUser,
  };

  return (dispatch) => {
    deleteBulkRequest(
      url,
      session,
      body,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function fetchExhibitorQr(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventqr?service=exhibitorqr`;

  return (dispatch) => {
    postRequest(
      url,
      values,
      session,
      dispatch,
      (response) => {
        // console.log("response", response);
        callback({ success: 1, data: response });
      },
      (error) => {
        // console.log("error", error);
        callback({ success: 0, message: error });
      }
    );
  };
}
